<p-inputGroup class="white w-40">
  <p-inputGroupAddon>
    <button
      class="pl-3"
      aria-label="Remove"
      (click)="incrementValue(-_step)"
      [disabled]="disabled || shouldDisableDecrement(_value)">
      <i class="text-[24px]" [ngClass]="'icon-minus'"></i>
    </button>
  </p-inputGroupAddon>
  <input pInputText type="number" [(ngModel)]="_value" class="increment" readonly/>
  <p-inputGroupAddon>
    <button
      class="pr-3"
      aria-label="Add"
      (click)="incrementValue(_step)"
      [disabled]="disabled || shouldDisableIncrement(_value)">
      <i class="text-[24px]" [ngClass]="'icon-plus'"></i>
    </button>
  </p-inputGroupAddon>
</p-inputGroup>
